<!-- Loading (Skeleton) -->
<ng-container *ngIf="loading; else contentReady">
  <p-skeleton height="180px" width="100%"></p-skeleton>

  <div class="container">
    <div class="flex align-items-center gap-3 p-3">
      <p-skeleton shape="circle" width="124px" height="124px"></p-skeleton>
      <p-skeleton width="220px" height="24px"></p-skeleton>
    </div>
    <div class="p-3 flex gap-2">
      <p-skeleton height="34px" width="120px"></p-skeleton>
      <p-skeleton height="34px" width="140px"></p-skeleton>
      <p-skeleton height="34px" width="100px"></p-skeleton>
    </div>
  </div>

  <div class="container">
    <section *ngFor="let s of [0,1]; trackBy: trackByIndex">
      <p-skeleton height="22px" width="220px" class="mb-3"></p-skeleton>
      <br>
      <div class="grid">
        <div class="col-12 md:col-6">
          <div class="card product skeleton">
            <div class="left">
              <p-skeleton width="88px" height="88px" borderRadius="12px"></p-skeleton>
              <p-skeleton width="56px" height="16px" class="mt-2"></p-skeleton>
            </div>
            <div class="right">
              <p-skeleton width="70%" height="18px"></p-skeleton>
              <p-skeleton width="90%" height="14px" class="mt-2"></p-skeleton>
              <p-skeleton width="80px" height="18px" class="mt-2"></p-skeleton>
              <div class="actions">
                <p-skeleton width="110px" height="36px"></p-skeleton>
              </div>
            </div>
          </div>
          <br>
        </div>
        <div class="col-12 md:col-6">
          <div class="card product skeleton">
            <div class="left">
              <p-skeleton width="88px" height="88px" borderRadius="12px"></p-skeleton>
              <p-skeleton width="56px" height="16px" class="mt-2"></p-skeleton>
            </div>
            <div class="right">
              <p-skeleton width="60%" height="18px"></p-skeleton>
              <p-skeleton width="85%" height="14px" class="mt-2"></p-skeleton>
              <p-skeleton width="80px" height="18px" class="mt-2"></p-skeleton>
              <div class="actions">
                <p-skeleton width="110px" height="36px"></p-skeleton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</ng-container>

<ng-template #contentReady>
  <!-- Erro -->
  <div *ngIf="erro" class="cardapio-erro">
    <i class="pi pi-exclamation-triangle cardapio-erro-icon"></i>
    <p class="cardapio-erro-texto">{{ erro }}</p>
  </div>

  <!-- Estado: CARDAPIO (visual Minishop) -->
  <ng-container *ngIf="!erro && estadoAtual === 'CARDAPIO'">

    <!-- CAPA (Banner) — oculta no mobile durante a busca para reduzir o header.
         Quando o estabelecimento nao tem banner (ou ele falha ao carregar) a
         area da capa nao e renderizada. -->
    <div class="capa"
         [class.capa--busca]="modoBusca"
         *ngIf="(estabelecimento.banner || estabelecimento.imagemDeTitulo) && !bannerComErro">
      <img [src]="estabelecimento.banner || estabelecimento.imagemDeTitulo"
           [alt]="estabelecimento.nome || 'Banner'"
           class="capa-img"
           (error)="bannerComErro = true">
    </div>

    <!-- ============================================================= -->
    <!-- LINHA 1: Faixa de marca (logo + nome + chips + busca + acoes)  -->
    <!-- Inspirado no header do Mercado Livre. Usa a cor de marca do    -->
    <!-- estabelecimento (--cardapio-accent) com primeiro plano claro.  -->
    <!-- ============================================================= -->
    <!-- HEADER STICKY: faixa de marca + categorias, fixas ao rolar a lista -->
    <div class="header-sticky">
    <div class="profile-wrapper">
      <header class="minishop-bar container">
        <!-- Identidade: logo + nome + status + chips de info rapida -->
        <div class="msb-identity">
          <img *ngIf="estabelecimento.logo && !logoComErro"
               [src]="estabelecimento.logo"
               [alt]="estabelecimento.nome"
               class="msb-logo"
               (error)="logoComErro = true" />
          <div *ngIf="!estabelecimento.logo || logoComErro" class="msb-logo msb-logo--placeholder">
            <i class="pi pi-image"></i>
          </div>

          <div class="msb-identity-text">
            <div class="msb-name-row">
              <h1 class="msb-name">{{ estabelecimento.nome }}</h1>
              <span class="status-badge"
                    [class.aberto]="estabelecimento.aberto"
                    [class.fechado]="!estabelecimento.aberto">
                {{ estabelecimento.aberto ? ('cardapio_digital.aberto' | translate) : ('cardapio_digital.fechado' | translate) }}
              </span>
            </div>

            <!-- Chips de info rapida -->
            <div class="msb-chips">
              <button type="button" class="msb-chip" (click)="onAbrirMenu()"
                      [attr.aria-label]="'cardapio_digital.informacoes' | translate">
                <i class="pi pi-info-circle"></i>
                <span>{{ 'cardapio_digital.informacoes' | translate }}</span>
              </button>
              <a *ngIf="estabelecimento.telefoneWhatsapp" class="msb-chip msb-chip--social msb-chip--whatsapp"
                 [href]="getWhatsappLink()" target="_blank" rel="noopener noreferrer"
                 aria-label="WhatsApp" title="WhatsApp">
                <i class="pi pi-whatsapp"></i>
              </a>
              <a *ngIf="estabelecimento.perfilInstagram" class="msb-chip msb-chip--social msb-chip--instagram"
                 [href]="getInstagramLink()" target="_blank" rel="noopener noreferrer"
                 aria-label="Instagram" title="Instagram">
                <i class="pi pi-instagram"></i>
              </a>
              <span class="msb-chip msb-chip--static" *ngIf="tempoEntregaTexto">
                <i class="pi pi-clock"></i>
                <span>{{ tempoEntregaTexto }}</span>
              </span>
              <span class="msb-chip msb-chip--static" *ngIf="estabelecimento.avaliacao != null">
                <i class="pi pi-star-fill"></i>
                <span>{{ estabelecimento.avaliacao }}</span>
              </span>
            </div>
          </div>
        </div>

        <!-- Busca permanente (desktop). No mobile aparece apenas com modoBusca. -->
        <div class="msb-search" [class.msb-search--aberta]="modoBusca">
          <i class="pi pi-search msb-search-icon"></i>
          <input id="searchInput" pInputText type="text"
                 class="msb-search-input"
                 [placeholder]="'cardapio_digital.buscar_placeholder' | translate"
                 [ngModel]="termoBusca"
                 (ngModelChange)="onTermoBuscaChange($event)"
                 (keyup.escape)="onTermoBuscaChange('')"
                 autocomplete="off" />
          <button type="button" class="msb-search-clear" *ngIf="termoBusca"
                  (click)="onTermoBuscaChange('')"
                  [attr.aria-label]="'cardapio_digital.buscar_placeholder' | translate">
            <i class="pi pi-times"></i>
          </button>
        </div>

        <!-- Acoes: meus pedidos + carrinho -->
        <div class="msb-actions">
          <button type="button" class="msb-action" *ngIf="temHistorico" (click)="irParaHistorico()"
                  [attr.aria-label]="'cardapio_digital.historico.botao_meus_pedidos' | translate">
            <i class="pi pi-clock"></i>
            <span class="msb-action-label">{{ 'cardapio_digital.historico.botao_meus_pedidos' | translate }}</span>
          </button>

          <button type="button" class="msb-action msb-action--cart" (click)="onVerPedido()"
                  [attr.aria-label]="'cardapio_digital.ver_pedido' | translate">
            <i class="pi pi-shopping-cart"></i>
            <span class="msb-action-label">{{ 'cardapio_digital.ver_pedido' | translate }}</span>
            <span class="msb-cart-badge" *ngIf="pedidoService.getQuantidadeTotal() > 0">
              {{ pedidoService.getQuantidadeTotal() }}
            </span>
          </button>
        </div>
      </header>
    </div>

    <!-- ============================================================= -->
    <!-- LINHA 2: Nav de categorias integrada ao header (mesma faixa de -->
    <!-- marca, logo abaixo das informacoes). Band full-width + sticky. -->
    <!-- ============================================================= -->
    <div class="nav-band">
      <div class="cardapio-nav-bar container">
        <!-- Busca ativa: input ocupa a barra no lugar do menu/destaques/abas -->
        <div class="nav-busca-inline" *ngIf="modoBusca">
          <i class="pi pi-search nav-busca-icon"></i>
          <input id="searchInputNav" pInputText type="text"
                 class="nav-busca-input"
                 [placeholder]="'cardapio_digital.buscar_placeholder' | translate"
                 [ngModel]="termoBusca"
                 (ngModelChange)="onTermoBuscaChange($event)"
                 (keyup.escape)="fecharBusca()"
                 autocomplete="off" />
          <button type="button" class="nav-icon nav-icon--hamburger" (click)="fecharBusca()"
                  [attr.aria-label]="'cardapio_digital.buscar_placeholder' | translate">
            <i class="pi pi-times"></i>
          </button>
        </div>

        <!-- Navegacao normal (oculta durante a busca) -->
        <ng-container *ngIf="!modoBusca">
        <div class="nav-hamburger-wrapper" #hamburgerWrapper>
          <button class="nav-icon nav-icon--hamburger"
                  (click)="toggleMenuCategoria()"
                  [attr.aria-expanded]="menuCategoriaAberto"
                  aria-haspopup="true"
                  [attr.aria-label]="'cardapio_digital.menu_categorias' | translate">
            <i class="pi pi-bars"></i>
          </button>

          <div class="nav-dropdown" *ngIf="menuCategoriaAberto" role="menu">
            <!-- Destaques fixos no topo: promocoes e novidades -->
            <button *ngIf="temProdutosPromocao" type="button"
                    class="nav-dropdown-item nav-dropdown-item--destaque"
                    role="menuitem"
                    [class.ativo]="categoriaAtivaId === SECAO_PROMOCAO"
                    (click)="selecionarCategoriaMenu(SECAO_PROMOCAO)">
              <i class="fas fa-tag"></i>
              <span>{{ 'cardapio_digital.destaque_promocoes' | translate }}</span>
            </button>
            <button *ngIf="temProdutosNovidade" type="button"
                    class="nav-dropdown-item nav-dropdown-item--destaque"
                    role="menuitem"
                    [class.ativo]="categoriaAtivaId === SECAO_NOVIDADE"
                    (click)="selecionarCategoriaMenu(SECAO_NOVIDADE)">
              <i class="pi pi-star-fill"></i>
              <span>{{ 'cardapio_digital.destaque_novidades' | translate }}</span>
            </button>

            <button *ngFor="let cat of categorias; trackBy: trackByCategoria"
                    class="nav-dropdown-item"
                    role="menuitem"
                    [class.ativo]="categoriaAtivaId === cat.id"
                    (click)="selecionarCategoriaMenu(cat.id)">
              {{ cat.nome }}
            </button>
          </div>
        </div>

        <!-- Abas fixas de destaque: promocoes/novidades (so quando ha itens) -->
        <div class="nav-fixos" *ngIf="temProdutosPromocao || temProdutosNovidade">
          <button *ngIf="temProdutosPromocao" type="button"
                  class="nav-tab nav-tab--destaque"
                  [class.ativo]="categoriaAtivaId === SECAO_PROMOCAO"
                  (click)="selectCategoria(SECAO_PROMOCAO)">
            <i class="fas fa-tag"></i>
            <span>{{ 'cardapio_digital.destaque_promocoes' | translate }}</span>
          </button>
          <button *ngIf="temProdutosNovidade" type="button"
                  class="nav-tab nav-tab--destaque"
                  [class.ativo]="categoriaAtivaId === SECAO_NOVIDADE"
                  (click)="selectCategoria(SECAO_NOVIDADE)">
            <i class="pi pi-star-fill"></i>
            <span>{{ 'cardapio_digital.destaque_novidades' | translate }}</span>
          </button>
        </div>

        <!-- Busca (apenas mobile): icone ao lado dos destaques; o input aparece
             na faixa de marca ao apertar (toggleBuscar). -->
        <button type="button" class="nav-icon nav-icon--hamburger nav-icon--busca-mobile"
                (click)="toggleBuscar()"
                [attr.aria-label]="'cardapio_digital.buscar_placeholder' | translate">
          <i class="pi" [class.pi-search]="!modoBusca" [class.pi-times]="modoBusca"></i>
        </button>

        <!-- Faixa rolavel de categorias. O esmaecimento nas pontas (classes
             tem-esquerda/tem-direita) sinaliza que ha mais categorias fora da
             tela; as setas aparecem em QUALQUER largura, e cada uma se esconde
             sozinha quando nao ha conteudo do seu lado (o [disabled] vem do
             estado podeRolar* da diretiva appDragScroll). -->
        <div class="nav-tabs-scroll">
          <button type="button"
                  class="nav-tabs-nav nav-tabs-nav--esquerda"
                  [disabled]="!dsTabs.podeRolarEsquerda"
                  [attr.aria-label]="'common.chips_scroll.anterior' | translate"
                  (click)="dsTabs.rolar(-1)">
            <i class="pi pi-chevron-left" aria-hidden="true"></i>
          </button>

          <div class="nav-tabs" role="tablist" #navTabs
               appDragScroll #dsTabs="appDragScroll"
               [class.tem-esquerda]="dsTabs.podeRolarEsquerda"
               [class.tem-direita]="dsTabs.podeRolarDireita">
            <button *ngFor="let cat of categorias; trackBy: trackByCategoria"
                    class="nav-tab"
                    role="tab"
                    [class.ativo]="categoriaAtivaId === cat.id"
                    [attr.aria-selected]="categoriaAtivaId === cat.id"
                    (click)="selectCategoria(cat.id)">
              {{ cat.nome }}
            </button>
          </div>

          <button type="button"
                  class="nav-tabs-nav nav-tabs-nav--direita"
                  [disabled]="!dsTabs.podeRolarDireita"
                  [attr.aria-label]="'common.chips_scroll.proximo' | translate"
                  (click)="dsTabs.rolar(1)">
            <i class="pi pi-chevron-right" aria-hidden="true"></i>
          </button>
        </div>
        </ng-container>
      </div>
    </div>
    </div><!-- /header-sticky -->

    <!-- LISTA DE PRODUTOS -->
    <main class="container list" style="padding-bottom: 100px;">
      <!-- Busca ativa: mostra resultados filtrados flat -->
      <ng-container *ngIf="termoBusca.trim().length > 0; else normalList">
        <div class="cardapio-produtos-grid">
          <ng-container *ngFor="let c of categorias; trackBy: trackByCategoria">
            <app-cardapio-produto-card
              *ngFor="let p of getProdutosFiltrados(c.id); trackBy: trackByProduto"
              [produto]="p"
              [moedaSimbolo]="moedaSimbolo"
              [moedaLocal]="moedaLocal"
              [quantidadeNoCarrinho]="quantidadeNoCarrinho(p.id)"
              (adicionar)="onAgregar($event)"
              (adicionarRapido)="onAdicionarRapido($event)"
              (compartilhar)="compartilharProduto($event)">
            </app-cardapio-produto-card>
          </ng-container>
        </div>

        <div class="empty" *ngIf="allFilteredCountCache === 0">
          {{ 'cardapio_digital.sem_resultados_busca' | translate }}
        </div>
      </ng-container>

      <!-- Lista normal: secoes de destaque (promo/novidade) ANTES das categorias -->
      <ng-template #normalList>
        <!-- Secao virtual: Promocoes -->
        <section *ngIf="temProdutosPromocao" [id]="'cat-' + SECAO_PROMOCAO">
          <div #catAnchor></div>
          <div class="cat-title-row">
            <h2 class="cat-title scale-up-center">
              <i class="fas fa-tag cat-title-icone cat-title-icone--promo"></i>
              {{ 'cardapio_digital.destaque_promocoes' | translate }}
            </h2>
          </div>
          <div class="cardapio-produtos-grid">
            <app-cardapio-produto-card
              *ngFor="let p of produtosPromocao(); trackBy: trackByProduto"
              [produto]="p"
              [moedaSimbolo]="moedaSimbolo"
              [moedaLocal]="moedaLocal"
              [quantidadeNoCarrinho]="quantidadeNoCarrinho(p.id)"
              (adicionar)="onAgregar($event)"
              (adicionarRapido)="onAdicionarRapido($event)"
              (compartilhar)="compartilharProduto($event)">
            </app-cardapio-produto-card>
          </div>
        </section>

        <!-- Secao virtual: Novidades -->
        <section *ngIf="temProdutosNovidade" [id]="'cat-' + SECAO_NOVIDADE">
          <div #catAnchor></div>
          <div class="cat-title-row">
            <h2 class="cat-title scale-up-center">
              <i class="pi pi-star-fill cat-title-icone cat-title-icone--novidade"></i>
              {{ 'cardapio_digital.destaque_novidades' | translate }}
            </h2>
          </div>
          <div class="cardapio-produtos-grid">
            <app-cardapio-produto-card
              *ngFor="let p of produtosNovidade(); trackBy: trackByProduto"
              [produto]="p"
              [moedaSimbolo]="moedaSimbolo"
              [moedaLocal]="moedaLocal"
              [quantidadeNoCarrinho]="quantidadeNoCarrinho(p.id)"
              (adicionar)="onAgregar($event)"
              (adicionarRapido)="onAdicionarRapido($event)"
              (compartilhar)="compartilharProduto($event)">
            </app-cardapio-produto-card>
          </div>
        </section>

        <section *ngFor="let c of categorias; let i = index; trackBy: trackByCategoria" [id]="'cat-' + c.id">
          <div #catAnchor></div>
          <div class="cat-title-row">
            <h2 class="cat-title scale-up-center">{{ c.nome }}</h2>
            <button type="button"
                    class="cat-share-btn"
                    (click)="compartilharCategoria(c); $event.stopPropagation()"
                    [attr.aria-label]="'cardapio_digital.compartilhar' | translate"
                    [title]="'cardapio_digital.compartilhar' | translate">
              <i class="pi pi-share-alt"></i>
            </button>
          </div>

          <div class="cardapio-produtos-grid">
            <app-cardapio-produto-card
              *ngFor="let p of getProdutosFiltrados(c.id); trackBy: trackByProduto"
              [produto]="p"
              [moedaSimbolo]="moedaSimbolo"
              [moedaLocal]="moedaLocal"
              [quantidadeNoCarrinho]="quantidadeNoCarrinho(p.id)"
              (adicionar)="onAgregar($event)"
              (adicionarRapido)="onAdicionarRapido($event)"
              (compartilhar)="compartilharProduto($event)">
            </app-cardapio-produto-card>
          </div>
        </section>
      </ng-template>
    </main>

    <!-- Modal de Opcoes (estilo Minishop) -->
    <app-cardapio-modificador-modal
      [visible]="modalVisivel"
      (visibleChange)="modalVisivel = $event"
      [produto]="produtoAtual"
      [moedaSimbolo]="moedaSimbolo"
      [moedaLocal]="moedaLocal"
      (confirmar)="onConfirmar($event)">
    </app-cardapio-modificador-modal>

    <!-- Footer do pedido (estilo Minishop) -->
    <app-cardapio-carrinho-footer
      [quantidade]="pedidoService.getQuantidadeTotal()"
      [total]="pedidoService.getTotalPedido()"
      [fundo]="estabelecimento.botoesCorDeFundo || '#007BFF'"
      [texto]="estabelecimento.botoesCorDaFonte || '#FFFFFF'"
      [moedaSimbolo]="moedaSimbolo"
      [moedaLocal]="moedaLocal"
      (verPedido)="onVerPedido()"
      (limparCarrinho)="pedidoService.clear()">
    </app-cardapio-carrinho-footer>

    <!-- Botao flutuante "voltar ao topo" -->
    <!-- Aparece ao rolar a listagem; fica acima da barra do carrinho quando ha itens. -->
    <button type="button"
            class="cardapio-scroll-top"
            [class.visivel]="mostrarBotaoTopo"
            [class.acima-carrinho]="temItensNoCarrinho"
            (click)="voltarAoTopo()"
            [attr.aria-label]="'cardapio_digital.voltar_ao_topo' | translate"
            [title]="'cardapio_digital.voltar_ao_topo' | translate">
      <i class="pi pi-arrow-up"></i>
    </button>
  </ng-container>

  <!-- Estado: DETALHES_PRODUTO -->
  <ng-container *ngIf="!erro && estadoAtual === 'DETALHES_PRODUTO'">

    <!-- Header reduzido (mesmo do menu): faixa de marca + categorias, fixo -->
    <div class="header-sticky">
    <div class="profile-wrapper">
      <header class="minishop-bar container">
        <div class="msb-identity">
          <img *ngIf="estabelecimento.logo && !logoComErro"
               [src]="estabelecimento.logo"
               [alt]="estabelecimento.nome"
               class="msb-logo"
               (error)="logoComErro = true" />
          <div *ngIf="!estabelecimento.logo || logoComErro" class="msb-logo msb-logo--placeholder">
            <i class="pi pi-image"></i>
          </div>

          <div class="msb-identity-text">
            <div class="msb-name-row">
              <h1 class="msb-name">{{ estabelecimento.nome }}</h1>
              <span class="status-badge"
                    [class.aberto]="estabelecimento.aberto"
                    [class.fechado]="!estabelecimento.aberto">
                {{ estabelecimento.aberto ? ('cardapio_digital.aberto' | translate) : ('cardapio_digital.fechado' | translate) }}
              </span>
            </div>

            <div class="msb-chips">
              <button type="button" class="msb-chip" (click)="onAbrirMenu()"
                      [attr.aria-label]="'cardapio_digital.informacoes' | translate">
                <i class="pi pi-info-circle"></i>
                <span>{{ 'cardapio_digital.informacoes' | translate }}</span>
              </button>
              <a *ngIf="estabelecimento.telefoneWhatsapp" class="msb-chip msb-chip--social msb-chip--whatsapp"
                 [href]="getWhatsappLink()" target="_blank" rel="noopener noreferrer"
                 aria-label="WhatsApp" title="WhatsApp">
                <i class="pi pi-whatsapp"></i>
              </a>
              <a *ngIf="estabelecimento.perfilInstagram" class="msb-chip msb-chip--social msb-chip--instagram"
                 [href]="getInstagramLink()" target="_blank" rel="noopener noreferrer"
                 aria-label="Instagram" title="Instagram">
                <i class="pi pi-instagram"></i>
              </a>
              <span class="msb-chip msb-chip--static" *ngIf="tempoEntregaTexto">
                <i class="pi pi-clock"></i>
                <span>{{ tempoEntregaTexto }}</span>
              </span>
              <span class="msb-chip msb-chip--static" *ngIf="estabelecimento.avaliacao != null">
                <i class="pi pi-star-fill"></i>
                <span>{{ estabelecimento.avaliacao }}</span>
              </span>
            </div>
          </div>
        </div>

        <div class="msb-search" [class.msb-search--aberta]="modoBusca">
          <i class="pi pi-search msb-search-icon"></i>
          <input id="searchInput" pInputText type="text"
                 class="msb-search-input"
                 [placeholder]="'cardapio_digital.buscar_placeholder' | translate"
                 [ngModel]="termoBusca"
                 (ngModelChange)="onTermoBuscaChange($event)"
                 (keyup.escape)="onTermoBuscaChange('')"
                 autocomplete="off" />
          <button type="button" class="msb-search-clear" *ngIf="termoBusca"
                  (click)="onTermoBuscaChange('')"
                  [attr.aria-label]="'cardapio_digital.buscar_placeholder' | translate">
            <i class="pi pi-times"></i>
          </button>
        </div>

        <div class="msb-actions">
          <button type="button" class="msb-action" *ngIf="temHistorico" (click)="irParaHistorico()"
                  [attr.aria-label]="'cardapio_digital.historico.botao_meus_pedidos' | translate">
            <i class="pi pi-clock"></i>
            <span class="msb-action-label">{{ 'cardapio_digital.historico.botao_meus_pedidos' | translate }}</span>
          </button>

          <button type="button" class="msb-action msb-action--cart" (click)="onVerPedido()"
                  [attr.aria-label]="'cardapio_digital.ver_pedido' | translate">
            <i class="pi pi-shopping-cart"></i>
            <span class="msb-action-label">{{ 'cardapio_digital.ver_pedido' | translate }}</span>
            <span class="msb-cart-badge" *ngIf="pedidoService.getQuantidadeTotal() > 0">
              {{ pedidoService.getQuantidadeTotal() }}
            </span>
          </button>
        </div>
      </header>
    </div>

    <!-- Nav de categorias (hamburger + abas) -->
    <div class="nav-band">
      <div class="cardapio-nav-bar container">
        <!-- Busca ativa: input ocupa a barra no lugar do menu/destaques/abas -->
        <div class="nav-busca-inline" *ngIf="modoBusca">
          <i class="pi pi-search nav-busca-icon"></i>
          <input id="searchInputNav" pInputText type="text"
                 class="nav-busca-input"
                 [placeholder]="'cardapio_digital.buscar_placeholder' | translate"
                 [ngModel]="termoBusca"
                 (ngModelChange)="onTermoBuscaChange($event)"
                 (keyup.escape)="fecharBusca()"
                 autocomplete="off" />
          <button type="button" class="nav-icon nav-icon--hamburger" (click)="fecharBusca()"
                  [attr.aria-label]="'cardapio_digital.buscar_placeholder' | translate">
            <i class="pi pi-times"></i>
          </button>
        </div>

        <!-- Navegacao normal (oculta durante a busca) -->
        <ng-container *ngIf="!modoBusca">
        <div class="nav-hamburger-wrapper" #hamburgerWrapper>
          <button class="nav-icon nav-icon--hamburger"
                  (click)="toggleMenuCategoria()"
                  [attr.aria-expanded]="menuCategoriaAberto"
                  aria-haspopup="true"
                  [attr.aria-label]="'cardapio_digital.menu_categorias' | translate">
            <i class="pi pi-bars"></i>
          </button>

          <div class="nav-dropdown" *ngIf="menuCategoriaAberto" role="menu">
            <!-- Destaques fixos no topo: promocoes e novidades -->
            <button *ngIf="temProdutosPromocao" type="button"
                    class="nav-dropdown-item nav-dropdown-item--destaque"
                    role="menuitem"
                    [class.ativo]="categoriaAtivaId === SECAO_PROMOCAO"
                    (click)="selecionarCategoriaMenu(SECAO_PROMOCAO)">
              <i class="fas fa-tag"></i>
              <span>{{ 'cardapio_digital.destaque_promocoes' | translate }}</span>
            </button>
            <button *ngIf="temProdutosNovidade" type="button"
                    class="nav-dropdown-item nav-dropdown-item--destaque"
                    role="menuitem"
                    [class.ativo]="categoriaAtivaId === SECAO_NOVIDADE"
                    (click)="selecionarCategoriaMenu(SECAO_NOVIDADE)">
              <i class="pi pi-star-fill"></i>
              <span>{{ 'cardapio_digital.destaque_novidades' | translate }}</span>
            </button>

            <button *ngFor="let cat of categorias; trackBy: trackByCategoria"
                    class="nav-dropdown-item"
                    role="menuitem"
                    [class.ativo]="categoriaAtivaId === cat.id"
                    (click)="selecionarCategoriaMenu(cat.id)">
              {{ cat.nome }}
            </button>
          </div>
        </div>

        <!-- Abas fixas de destaque: promocoes/novidades (so quando ha itens) -->
        <div class="nav-fixos" *ngIf="temProdutosPromocao || temProdutosNovidade">
          <button *ngIf="temProdutosPromocao" type="button"
                  class="nav-tab nav-tab--destaque"
                  [class.ativo]="categoriaAtivaId === SECAO_PROMOCAO"
                  (click)="selectCategoria(SECAO_PROMOCAO)">
            <i class="fas fa-tag"></i>
            <span>{{ 'cardapio_digital.destaque_promocoes' | translate }}</span>
          </button>
          <button *ngIf="temProdutosNovidade" type="button"
                  class="nav-tab nav-tab--destaque"
                  [class.ativo]="categoriaAtivaId === SECAO_NOVIDADE"
                  (click)="selectCategoria(SECAO_NOVIDADE)">
            <i class="pi pi-star-fill"></i>
            <span>{{ 'cardapio_digital.destaque_novidades' | translate }}</span>
          </button>
        </div>

        <!-- Busca (apenas mobile): icone ao lado dos destaques; o input aparece
             na faixa de marca ao apertar (toggleBuscar). -->
        <button type="button" class="nav-icon nav-icon--hamburger nav-icon--busca-mobile"
                (click)="toggleBuscar()"
                [attr.aria-label]="'cardapio_digital.buscar_placeholder' | translate">
          <i class="pi" [class.pi-search]="!modoBusca" [class.pi-times]="modoBusca"></i>
        </button>

        <!-- Faixa rolavel de categorias. O esmaecimento nas pontas (classes
             tem-esquerda/tem-direita) sinaliza que ha mais categorias fora da
             tela; as setas aparecem em QUALQUER largura, e cada uma se esconde
             sozinha quando nao ha conteudo do seu lado (o [disabled] vem do
             estado podeRolar* da diretiva appDragScroll). -->
        <div class="nav-tabs-scroll">
          <button type="button"
                  class="nav-tabs-nav nav-tabs-nav--esquerda"
                  [disabled]="!dsTabs.podeRolarEsquerda"
                  [attr.aria-label]="'common.chips_scroll.anterior' | translate"
                  (click)="dsTabs.rolar(-1)">
            <i class="pi pi-chevron-left" aria-hidden="true"></i>
          </button>

          <div class="nav-tabs" role="tablist" #navTabs
               appDragScroll #dsTabs="appDragScroll"
               [class.tem-esquerda]="dsTabs.podeRolarEsquerda"
               [class.tem-direita]="dsTabs.podeRolarDireita">
            <button *ngFor="let cat of categorias; trackBy: trackByCategoria"
                    class="nav-tab"
                    role="tab"
                    [class.ativo]="categoriaAtivaId === cat.id"
                    [attr.aria-selected]="categoriaAtivaId === cat.id"
                    (click)="selectCategoria(cat.id)">
              {{ cat.nome }}
            </button>
          </div>

          <button type="button"
                  class="nav-tabs-nav nav-tabs-nav--direita"
                  [disabled]="!dsTabs.podeRolarDireita"
                  [attr.aria-label]="'common.chips_scroll.proximo' | translate"
                  (click)="dsTabs.rolar(1)">
            <i class="pi pi-chevron-right" aria-hidden="true"></i>
          </button>
        </div>
        </ng-container>
      </div>
    </div>
    </div><!-- /header-sticky -->

    <app-cardapio-produto-detalhe
      [produto]="produtoSelecionado"
      [categoriaNome]="categoriaNomeDetalhe"
      [idEmpresa]="idEmpresa"
      [moedaSimbolo]="moedaSimbolo"
      [moedaLocal]="moedaLocal"
      [estabelecimento]="estabelecimento"
      [freteConfig]="freteConfig"
      [quantidadeNoCarrinho]="produtoSelecionado ? quantidadeNoCarrinho(produtoSelecionado.id) : 0"
      (confirmar)="onDetalheConfirmar($event)"
      (voltar)="onDetalheVoltar()"
      (compartilhar)="onDetalheCompartilhar()">
    </app-cardapio-produto-detalhe>
  </ng-container>

  <!-- Estado: CARRINHO -->
  <ng-container *ngIf="!erro && estadoAtual === 'CARRINHO'">
    <app-cardapio-carrinho
      [slug]="slug || 'preview'"
      [moedaSimbolo]="moedaSimbolo"
      [moedaLocal]="moedaLocal"
      [todosOsProdutos]="todosOsProdutos"
      [exigenciasDoPedido]="exigenciasDoPedido"
      (lojaIndisponivel)="onLojaIndisponivel()"
      (voltar)="irParaCardapio()"
      (finalizar)="irParaCheckout()"
      (adicionarProduto)="onAdicionarProdutoSugerido($event)"
      (adicionarProdutoRapido)="onAdicionarRapido($event)"
      (selecionarTipo)="onSelecionarTipoServico($event)">
    </app-cardapio-carrinho>
  </ng-container>

  <!-- Estado: TRACKING (acompanhamento do pedido) -->
  <ng-container *ngIf="!erro && estadoAtual === 'TRACKING' && trackingAtual">
    <app-cardapio-tracking
      [tracking]="trackingAtual"
      [cobrancaQr]="cobrancaQr"
      [slug]="slug"
      [moedaSimbolo]="moedaSimbolo"
      [moedaLocal]="moedaLocal"
      [carrinhoTemItens]="pedidoService.itens.length > 0"
      [veioDoHistorico]="veioDoHistorico"
      (voltarAoCardapio)="irParaCardapioAposTracking()"
      (voltarDoHistorico)="voltarParaHistorico()"
      (copiarPedido)="onCopiarPedido($event)">
    </app-cardapio-tracking>
  </ng-container>

  <!-- Estado: HISTORICO -->
  <ng-container *ngIf="!erro && estadoAtual === 'HISTORICO'">
    <app-cardapio-historico
      [pedidos]="pedidosHistorico"
      [moedaSimbolo]="moedaSimbolo"
      [moedaLocal]="moedaLocal"
      (voltar)="irParaCardapio()"
      (limparHistorico)="onLimparHistorico()"
      (verTracking)="onVerTrackingDoHistorico($event)">
    </app-cardapio-historico>
  </ng-container>

  <!-- Modal de Checkout (p-dialog) -->
  <app-cardapio-checkout
    [visible]="checkoutVisivel"
    (visibleChange)="checkoutVisivel = $event"
    [itens]="pedidoService.itens"
    [estabelecimento]="estabelecimento"
    [freteConfig]="freteConfig"
    [formasDePagamentoConfig]="formasDePagamentoConfig"
    [exigenciasDoPedido]="exigenciasDoPedido"
    [freteDistancia]="freteDistancia"
    [moedaSimbolo]="moedaSimbolo"
    [moedaLocal]="moedaLocal"
    [tipoPedidoInicial]="tipoPedidoSelecionado"
    [nomeClienteInicial]="nomeClienteCheckout"
    [telefoneInicial]="telefoneCheckout"
    [enderecoInicial]="enderecoCheckout"
    [numeroMesaInicial]="numeroMesaCheckout"
    [numeroComandaInicial]="numeroComandaCheckout"
    [rucInicial]="rucCheckout"
    [ciInicial]="ciCheckout"
    [estadoCobrancaQr]="estadoCobrancaQr"
    (voltar)="onCheckoutVoltar()"
    (gerarCobrancaQr)="onGerarCobrancaQr($event)"
    (cancelarCobrancaQr)="onCancelarCobrancaQr()"
    (pedidoFinalizado)="onPedidoFinalizado($event)">
  </app-cardapio-checkout>
</ng-template>

<!-- Sidebar de informacoes (estilo OlaClick) — fora dos estados para abrir
     em qualquer tela (menu, detalhe, carrinho, etc.) -->
<app-cardapio-sidebar
  *ngIf="estabelecimento"
  [visible]="sidebarVisivel"
  (visibleChange)="sidebarVisivel = $event"
  [estabelecimento]="estabelecimento"
  [temHistorico]="temHistorico"
  (verHistorico)="irParaHistorico()">
</app-cardapio-sidebar>

<!-- Dialog de Loja Fechada -->
<app-cardapio-loja-fechada-dialog
  *ngIf="estabelecimento"
  [(visible)]="lojaFechadaVisivel"
  [estabelecimento]="estabelecimento">
</app-cardapio-loja-fechada-dialog>

<!-- Aviso modal unico da tela (falha de envio, campo obrigatorio, etc.) -->
<app-cardapio-aviso-dialog
  [(visible)]="aviso.visivel"
  [titulo]="aviso.titulo"
  [mensagem]="aviso.mensagem"
  [textoBotao]="aviso.textoBotao">
</app-cardapio-aviso-dialog>

<p-toast position="top-center"></p-toast>
